import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconCopyLinkStyle0 = cosmosIconCss;

const CosmosIconCopyLink$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCopyLink extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '45f1cbfaf449557d363035e1cdad10eb875b87d1', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'f349cb28ca80c5792047823eebe0efff820cd7cf', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '7ce50a851ecded467ee0a941b157a82dc3b550af', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-11Zm8.058 5.161L14.53 10.19a1.557 1.557 0 0 1-1.13.462 1.852 1.852 0 0 1-1.101-.369c-.17-.123-.19-.3-.015-.493l.276-.3a.367.367 0 0 1 .474-.061.505.505 0 0 0 .664-.031l1.551-1.552a.67.67 0 0 0-.115-.938.798.798 0 0 0-.539-.262.538.538 0 0 0-.392.138l-.015.017a.19.19 0 0 1-.284 0l-.539-.524a.19.19 0 0 1 0-.284l.016-.015c.338-.33.799-.502 1.27-.474.492.025.957.237 1.299.592a1.8 1.8 0 0 1 .108 2.566Zm-3.357 3.323-.032.03a1.65 1.65 0 0 1-1.184.486 1.99 1.99 0 0 1-1.385-.592 1.814 1.814 0 0 1-.115-2.578l1.517-1.516a1.665 1.665 0 0 1 2.23-.095.298.298 0 0 1 .024.493l-.285.3a.369.369 0 0 1-.473.061.507.507 0 0 0-.664.031l-1.543 1.543a.679.679 0 0 0 .115.948c.229.284.64.335.931.116l.095-.085a.196.196 0 0 1 .231.054l.531.523a.19.19 0 0 1 .007.281Z", fill: "currentColor" }), h("path", { key: '245d75c6e226077471cc7b49ea6dde6de062f370', d: "M13.5 16a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V8a.5.5 0 0 1-.5.5h-1v9h7v-1a.5.5 0 0 1 .5-.5h.5Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconCopyLinkStyle0; }
}, [1, "cosmos-icon-copy-link", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-copy-link"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-copy-link":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCopyLink$1);
            }
            break;
    } });
}

const CosmosIconCopyLink = CosmosIconCopyLink$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCopyLink, defineCustomElement };
